"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfficeAccountRoutes = void 0;
var OfficeAccountRoutes;
(function (OfficeAccountRoutes) {
    OfficeAccountRoutes["BasePrefix"] = "office-accounts";
    OfficeAccountRoutes["ById"] = ":officeAccountId";
    OfficeAccountRoutes["All"] = "all";
    OfficeAccountRoutes["List"] = "list";
})(OfficeAccountRoutes = exports.OfficeAccountRoutes || (exports.OfficeAccountRoutes = {}));
